var openCart; // for nosto

$(document).ready(function () {
  // module to work with a Cart. It can be extended as needed

  var Cart = (function () {
    function _add(upsellId) {
      var data = {
        quantity: 1,
        id: upsellId,
      };

      return fetch('/cart/add.js', _preparePostData(data)).then(function (res) {
        return res.json();
      });
    }

    function _preparePostData(data) {
      return {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
      }
    }

    function _getCart() {
      return fetch('/cart.js').then(function (res) {
        return res.json();
      });
    }

    return {
      add: _add,
      get: _getCart,
    }
  })();

  function getRandomInt( max ) {
    return Math.floor( Math.random() * Math.floor( max ) + 1 );
  }

  // show random image in advantages block on product page
  var adventagesImg = $(".b-advantages__item .b-advantages__img").first();
  var adventagesImgSrc = adventagesImg.attr('src');
  if (adventagesImgSrc) {
    var newSrc = adventagesImgSrc.replace('advantages_2', 'advantages_' + getRandomInt(5));
    adventagesImg.attr('src', newSrc);
  }

  $('input[name="addToOrder"]').click(function () {
    var variantId = $(this).val();
    Cart.get().then(function (cart) {
      var upsellProduct = cart.items.filter(function (item) {
        return item.id == variantId
      });
      if (upsellProduct.length === 0) {
        Cart.add(variantId).then(function(res) {
          $('.c-cart-link')[0].click();
        });
      } else {
        $.post('/cart/update.js', {
          updates: {
            [+variantId]: 0,
          }
        });
      }
    });
  });

  function isMobile() {
    var isMobile = false; //initiate as false
    // device detection
    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
       || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
      isMobile = true;
    }
    return isMobile;
  }

  // only for mobile
  if (isMobile()) {
    //Slider.init();
    // move slick arrows down on product slider (product page)
    var slickArrow = $('.product-single-wrapper .slick-arrow');
    var slickArrowArr =  Array.prototype.slice.call(slickArrow);
    for (var i=0, len = slickArrowArr.length; i < len; i++) {
      slickArrowArr[i].classList.add('slick-arrow__to_down');
    }
  }

  // module for check swipe event on mobile devices
    var Swipe = (function() {
    var xDown = null;
    var yDown = null;

    function getTouches(evt) {
      return evt.touches ||             // browser API
        evt.originalEvent.touches; // jQuery
    }

    function handleTouchStart(evt) {
      var firstTouch = getTouches(evt)[0];
      xDown = firstTouch.clientX;
      yDown = firstTouch.clientY;
    };

    function handleTouchMove(evt, handler) {
      if ( ! xDown || ! yDown ) {
        return;
      }

      var xUp = evt.touches[0].clientX;
      var yUp = evt.touches[0].clientY;
      var xDiff = xDown - xUp;
      var yDiff = yDown - yUp;

      if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
        if ( xDiff > 0 ) {
          handler(1);
        } else {
          handler(-1);
        }
      }
      /* reset values */
      xDown = null;
      yDown = null;
    };

    return {
      handleTouchStart: handleTouchStart,
      handleTouchMove: handleTouchMove,
    }
  })();

  if($(window).width() < 591){
    $('.cv__recommndedProducts').slick({
      infinite: true,
      dots: false,
      arrows: false,
      slidesToShow: 2,
      slidesToScroll: 3,
      vertical: false,
      centerMode: true,
      centerPadding: '10px'
    });
  }

  openCart = function( element ) { // for nosto
    var id = element.attr('data-id');
    Cart.add( id ).then(function(res) {
      $('.c-cart-link')[0].click();
    });
  }

  $( 'body' ).on( 'click', '.c-add-to-cart-open', function( e ) { // onlick for buildBambuserList
    e.preventDefault();
    openCart( $(this) );
  });

  $( 'body' ).on( 'click', '.c-add-to-cart', function( e ) { // onlick for buildBambuserList
    e.preventDefault();
    var id = $(this).attr('data-id');
    Cart.add( id ).then(function(res) {
      ajaxCart.load();
    });
  });
});

$('.cartupsell-button').click(function(){
  $(this).siblings('.cartupsell-products').slideToggle();
});

$('.cartdrawer-overlay,#CartDrawer .js-drawer-close').click(function(e){
  $('.cartdrawer-overlay').removeClass('cart-isopen');
  if($('.cartdrawer-overlay').is(e.target)){
    $('.js-drawer-close').trigger('click');
  }
});
$('#CartContainer').on('click','#cart__checkout',function(){
  $('body').addClass('loader_active');
});
